import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'

Vue.use(Router)

export default new Router({
    mode: 'history',
    linkExactActiveClass: 'active',
    base: process.env.BASE_URL,
    routes: [
        //{
        //    path: '/',
        //    name: 'home',
        //    component: Home
        //},
        {
            path: '/',
            name: 'expense-report',
            component: () => import('./views/ExpenseReport.vue')
        },
        {
            path: '/institutional-documents',
            name: 'institutional-documents',
            component: () => import('./views/InstitutionalDocuments.vue')
        },
        {
            path: '/receipt-bucket',
            name: 'receipt-bucket',
            component: () => import('./views/ReceiptBucket.vue')
        },
        {
            path: '/projects',
            name: 'projects',
            component: () => import('./views/Projects.vue')
        },
        {
            path: '/projects/edit/:id?',
            name: 'projects-edit',
            component: () => import('./views/ProjectsEdit.vue')
        },
        {
            path: '/projectusers',
            name: 'project-users',
            component: () => import('./views/ProjectUsers.vue')
        },
        {
            path: '/projectusers/edit/:id?',
            name: 'project-users-edit',
            component: () => import('./views/ProjectUsersEdit.vue')
        },
        {
            path: '/expense-report',
            name: 'expense-report',
            component: () => import('./views/ExpenseReport.vue')
        },
        {
            path: '/travel-expense-report/:erid?',
            name: 'travel-expense-report',
            component: () => import('./views/TripProfile.vue')
        },
        {
            path: '/travel-expense-report/:erid/print',
            name: 'travel-expense-report-print',
            component: () => import('./views/TERPrint.vue')
        },
        {
            path: '/air/:erid',
            name: 'air',
            component: () => import('./views/Air.vue')
        },
        {
            path: '/lodging/:erid',
            name: 'lodging',
            component: () => import('./views/Lodging.vue')
        },
        {
            path: '/meals/:erid',
            name: 'meals',
            component: () => import('./views/Meals.vue')
        },
        {
            path: '/rental-car/:erid',
            name: 'rental-car',
            component: () => import('./views/RentalCar.vue')
        },
        {
            path: '/other/:erid',
            name: 'other',
            component: () => import('./views/Other.vue')
        },
        {
            path: '/review-submit/:erid',
            name: 'review-submit',
            component: () => import('./views/ReviewSubmit.vue')
        },
        {
            path: '/admin-approval',
            name: 'admin-approval',
            component: () => import('./views/AdminApprovals.vue')
        },
        {
            path: '/admin2-approval',
            name: 'admin2-approval',
            component: () => import('./views/AdminTwoApprovals.vue')
        },
        {
            path: '/pending-payments',
            name: 'pending-payments',
            component: () => import('./views/PendingPayments.vue')
        },
        {
            path: '/pi-approval',
            name: 'pi-approval',
            component: () => import('./views/PIApprovals.vue')
        },
        {
            path: '/your-pending-approvals',
            name: 'your-pending-approvals',
            component: () => import('./views/YourPendingApprovals.vue')
        },
        {
            path: '/summary-approval/:erid',
            name: 'summary-approval',
            component: () => import('./views/Approval.vue')
        },
        {
            path: '/reports-in-progress/:admin',
            name: 'reports-in-progress',
            component: () => import('./views/ReportsInProgress.vue')
        },
        {
            path: '/submitted-paid-reports',
            name: 'submitted-paid-reports',
            component: () => import('./views/PastPaidReport.vue')
        },
        {
            path: '/misc-expense-report/:erid?',
            name: 'misc-expense-report',
            component: () => import('./views/MiscExpenseReport.vue')
        },
        {
            path: '/misc-expense-report/:erid/print',
            name: 'misc-expense-report-print',
            component: () => import('./views/MERPrint.vue')
        },
        {
            path: '/admin-analysis',
            name: 'admin-analysis',
            component: () => import('./views/AdminAnalysisReport.vue')
        },
        {
            path: '/pi-analysis',
            name: 'pi-analysis',
            component: () => import('./views/PIAnalysisReport.vue')
        },
        {
            path: '/admin-gl-report',
            name: 'admin-gl-report',
            component: () => import('./views/AdminGLReport.vue')
        },
        {
            path: '/import-per-diem',
            name: 'import-per-diem',
            component: () => import('./views/ImportForeignOtherPerDiem.vue')
        },
        {//not found redirect to home
            path: '*',
            redirect: '/'
        },
    ]
})
